<template>
  <div>
    <div id="logo">
      <img src="../assets/logo.jpg" alt="">
    </div>
    <div id="title">
      查询结果
    </div>
    <div id="table">
      <table style="background-color:#f0f0f0">
        <tr>
          <td style="width:35%">会员编号：</td>
          <td>{{data.idNumber}}</td>
        </tr>
        <tr>
          <td>姓名：</td>
          <td>{{data.name}}</td>
        </tr>
        <tr>
          <td>性别：</td>
          <td>{{data.sex}}</td>
        </tr>
        <tr>
          <td>身份证号码：</td>
          <td>{{data.idCard}}</td>
        </tr>
        <!-- <tr>
          <td>电话：</td>
          <td>{{data.mobile}}</td>
        </tr>
        <tr>
          <td>电子邮箱：</td>
          <td>{{data.email}}</td>
        </tr> -->
      </table>

    </div>

    <div id="quanyi">
      中国摄影家艺术协会享受的权益
    </div>

    <div id="quanyiInfo">
      <ol>
        <li>获得终身会员证一件;</li>
        <li>会员可以参加中国摄影家艺术协会举办的各种摄影比赛;</li>
        <li>会员能优先参加中国摄影家艺术协会举办的摄影交流、联谊活动;</li>
        <li>国内部分景点享受免票或优惠。</li>
      </ol>
    </div>

    <br>
    <br>
    <br>
    <br>

    <div id="footer">
      <div id="redrect"></div>
      <div id="copyright">版权所有&copy;2023 中国摄影家艺术协会</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: {}
    }
  },

  created () {
    var datastring = window.sessionStorage.getItem('userInfo')
    if (!datastring) {
      window.alert('未发现用户信息')
      return this.$router.replace('/')
    }
    var data
    try {
      data = JSON.parse(datastring)
      this.data = data
    } catch (err) {
      window.alert('用户信息错误')
      return this.$router.replace('/')
    }
    this.data = data
    console.log(this.data)
  },

  methods: {
    async searchClick () {
      const { data: res } = await this.$http.get('user/query', {
        params: { name: this.name, idCard: this.idCard }
      })
      if (res.meta.status !== 200) {
        window.alert(res.meta.msg)
      } else {
        console.log('asdadf')
      }
    }
  }
}
</script>

<style>

</style>
